import React from 'react';
import { ClientDataTypes } from 'interfaces/robot_dashboard';
import moment from 'moment';
import { Link } from 'react-router-dom';

interface DataTableItem {
  clientId: number;
  cnpj: string | null;
  lastDispute: string | null;
  nextDispute: string | null;
  companyName: string | null;
}

const ID_GROW = 0;
const CNPJ_GROW = 3;
const COMPANY_NAME_GROW = 6;
const LAST_DISPUTE_GROW = 3;
const NEXT_DISPUTE_GROW = 3;
const BUTTON_GROW = 0;

export const datatableData = (clientList: Array<ClientDataTypes>) => {
  return clientList.map((client) => {
    return {
      clientId: client.clientId,
      cnpj: client.cnpj,
      lastDispute: client.lastDispute,
      nextDispute: client.nextDispute,
      companyName: client.companyName,
    };
  });
};

export const datatableColumns = () => {
  return [
    {
      name: 'ID',
      width: '110px',
      sortable: true,
      selector: (data: DataTableItem) => data.clientId,
      center: false,
      grow: ID_GROW,
      cell: (data: DataTableItem) => <div>{data.clientId}</div>,
    },
    {
      name: 'CNPJ',
      sortable: true,
      selector: (data: DataTableItem) => data.cnpj || '',
      center: false,
      grow: CNPJ_GROW,
      cell: (data: DataTableItem) => <div>{data.cnpj}</div>,
    },
    {
      name: 'Razão social',
      sortable: true,
      selector: (data: DataTableItem) => data.companyName || '',
      center: false,
      grow: COMPANY_NAME_GROW,
      cell: (data: DataTableItem) => <div>{data.companyName}</div>,
    },
    {
      name: 'Última disputa',
      width: '170px',
      sortable: true,
      selector: (data: DataTableItem) => data.lastDispute || '',
      center: false,
      grow: LAST_DISPUTE_GROW,
      cell: (data: DataTableItem) => (
        <div className="text-secondary">
          {data.lastDispute ? moment.parseZone(data.lastDispute).format('DD/MM/YYYY, h:mm') : '--'}
        </div>
      ),
    },
    {
      name: 'Próxima disputa',
      width: '170px',
      sortable: true,
      selector: (data: DataTableItem) => data.nextDispute || '',
      center: false,
      grow: NEXT_DISPUTE_GROW,
      cell: (data: DataTableItem) => (
        <div className="text-success">
          {data.nextDispute ? moment.parseZone(data.nextDispute).format('DD/MM/YYYY, h:mm') : '--'}
        </div>
      ),
    },
    {
      name: '',
      width: '130px',
      center: true,
      allowOverflow: true,
      grow: BUTTON_GROW,
      cell: (data: DataTableItem) => (
        <Link
          className="btn btn-sm btn-primary text-white d-flex"
          to={`/robo_dashboard_user/${data.clientId}`}
        >
          <span className="material-icons">visibility</span>
        </Link>
      ),
    },
  ];
};
